export const BROWSER_MODE_DISABLED_MESSAGE =
  'Direct browser access in the InfluxDB datasource is no longer available. Switch to server access mode.';
